import React, { useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import { LanguageSplash } from './components/LanguageSplash';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { BookCoverSection } from './components/BookCoverSection';
import { SocialProofSection } from './components/SocialProofSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { AuthorsSection } from './components/AuthorsSection';
import { ChaptersSection } from './components/ChaptersSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ProductSection } from './components/ProductSection';
import { FooterCTA } from './components/FooterCTA';
function AppContent() {
  const {
    showSplash,
    lang
  } = useLanguage();
  useEffect(() => {
    document.title = lang === 'es' ? 'DMT: La Molécula de Dios' : 'DMT: The Spirit Molecule';
  }, [lang]);
  return <div className="relative w-full min-h-screen bg-void text-white antialiased overflow-hidden" data-id="element-0">
      {/* Language Splash */}
      <AnimatePresence data-id="element-1">{showSplash && <LanguageSplash data-id="element-2" />}</AnimatePresence>

      {/* Background Eye Image */}
      <div className="fixed inset-0 z-0 w-full h-full pointer-events-none" data-id="element-3">
        <img src="https://cdn.magicpatterns.com/uploads/4r9GwTdC2DbovVpB5eWkuB/Screenshot_2026-02-19_at_2.40.53_PM.png" alt="" role="presentation" loading="eager" decoding="async" className="absolute inset-0 w-full h-full object-cover object-center opacity-30 scale-110 gpu-layer" data-id="element-4" />
        <div className="absolute inset-0 bg-void/40 mix-blend-multiply" data-id="element-5" />
      </div>

      {/* Content wrapper */}
      {!showSplash && <div className="relative z-10" data-id="element-6">
          <Navbar data-id="element-7" />
          <BookCoverSection data-id="element-8" />
          <HeroSection data-id="element-9" />
          <SocialProofSection data-id="element-10" />
          <ProblemSection data-id="element-11" />
          <SolutionSection data-id="element-12" />
          <AuthorsSection data-id="element-13" />
          <ChaptersSection data-id="element-14" />
          <TestimonialsSection data-id="element-15" />
          <ProductSection data-id="element-16" />
          <FooterCTA data-id="element-17" />
        </div>}
    </div>;
}
export function App() {
  return <LanguageProvider data-id="element-18">
      <AppContent data-id="element-19" />
    </LanguageProvider>;
}